var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{ref:"text",domProps:{"innerHTML":_vm._s(_vm.purpose.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }